import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import AssigneeOptionContainer from './AssigneeOptionContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const UnassignButtonOptionHD = ({
  currentAssigneeId,
  onClick
}) => /*#__PURE__*/_jsx("div", {
  className: "p-bottom-1",
  children: /*#__PURE__*/_jsx(AssigneeOptionContainer, {
    children: /*#__PURE__*/_jsx("div", {
      className: "justify-end",
      children: /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "reassignment-dropdown-unassign_button",
        use: "tertiary-light",
        size: "extra-small",
        disabled: currentAssigneeId === null,
        onClick: onClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.reassignment.unassignUserLabel"
        })
      })
    })
  })
});
UnassignButtonOptionHD.displayName = 'UnassignButtonOptionHD';
export default UnassignButtonOptionHD;